import type { FC } from 'react';
import type { FieldsAndSys, QuoteEntry } from 'src/types/contentful';
import { CmsQuote } from './CmsQuote';
import { CmsQuoteCentered } from './CmsQuoteCentered';
import Quote from 'src/components-v3/Quote/Quote';

export const CmsQuoteSwitch: FC<FieldsAndSys<QuoteEntry>> = ({
  fields,
  sys,
}) => {
  switch (fields.appearance) {
    case 'Centered':
      return <CmsQuoteCentered fields={fields} sys={sys} />;
    case 'Standalone':
      return <Quote fields={fields} sys={sys} />;
    case 'Default':
    default:
      return <CmsQuote fields={fields} sys={sys} />;
  }
};
